import { ReactNode } from 'react'
import { BodyContainer, Cell, Header, Row, Table } from 'wed-components-beta'

export type TableMakerType<T> = {
  header: ReactNode
  field: keyof T
  renderComponent?: (value: T[keyof T]) => ReactNode
  flexGrow?: boolean
  width: number
}

type Props<T> = {
  format: TableMakerType<T>[]
  data: T[]
}

export default function TableMaker<T>({ format, data }: Props<T>) {
  return <Table>
    <BodyContainer flexGrow={1}>
      {/* Header */}
      <Header>
        {
          format.map((column, index) => <Cell key={index} width={column.width} flexGrow={column.flexGrow}>
            {column.header}
          </Cell>)
        }
      </Header>
      {/* Body */}
      {
        data.length ?
          data.map((row, index) => <Row key={index}>
            {
              format.map((format, cellIndex) => <Cell key={cellIndex} width={format.width} flexGrow={format.flexGrow}>
                {format.renderComponent ? format.renderComponent(row[format.field]) : row[format.field]}
              </Cell>)
            }
          </Row>)
          :
          <Row>
            <Cell flexGrow>
              No data to show.
            </Cell>
          </Row>
      }
    </BodyContainer>
  </Table>
}
